import { Command } from 'cmdk';
import type { IconName } from '@customerio/pluma-icons';
import { Box, Flex, Icon, KeyboardShortcut, Text } from '@customerio/pluma-components/react';
import type { KeyboardShortcutProps } from '@customerio/pluma-components/react';

type CommandPrimerItemProps = {
  description?: string;
  hotkey: KeyboardShortcutProps['hotkey'];
  icon: IconName;
  label: string;
  onSelect: () => void;
  value: string;
};

export function CommandPrimerItem({ description, hotkey, icon, label, onSelect, value }: CommandPrimerItemProps) {
  return (
    <Command.Item value={value} onSelect={onSelect} asChild>
      <Flex alignItems="flex-start" gap="050">
        <Icon mt="025" name={icon} size="sm" color="base" />
        <Flex direction="column" flex={1} minW="0">
          <Text text="product-p" truncate>
            {label}
          </Text>
          {description != null ? (
            <Text size="xxs" color="subtle" truncate>
              {description}
            </Text>
          ) : null}
        </Flex>
        <Box mt="025">
          <KeyboardShortcut hotkey={hotkey} />
        </Box>
      </Flex>
    </Command.Item>
  );
}
